import React from "react";
import SEO from "components/seo";
import Layout from "components/layout/index";
import LosAngeles from "components/locationIndexPages/LosAngeles/index";

function index() {
  const title = "Los Angeles Translation Services – in 100+ Languages";
  const description =
    "Need for translation services in Los Angeles? Tomedes provides translation, localization, and interpretation services in 120+ languages with rapid delivery and 24/7 support.";
  const keywords = "Translation Services in Los Angeles";
  return (
    <Layout>
      <SEO
        title={title}
        description={description}
        keywords={keywords}
        slug="/locations/los-angeles-translation-services/"
      />
      <LosAngeles />
    </Layout>
  );
}

export default index;
